import React, { useEffect, useState } from "react";
import { AnalysisPriority } from "../../../../models/general/analysis-priority";
import DraggableTable from "../../../../components/table/table-dragdrop-line.component";
import { Box, Paper, TableCell, Typography } from "@mui/material";
import { translate } from "../../../../translate/translate";
import WarningTooltip from "../../../../components/tooltip/warning-tooltip";
import { Info } from "@mui/icons-material";

const SimulationAnalysisPriorityPageComponent = ({ handleSelectPriority, dataPriority }: any) => {
  const [data, setData] = useState<AnalysisPriority[]>(dataPriority);

  useEffect(() => {
    updatePriorities(dataPriority);
  }, []);

  useEffect(() => {
    handleSelectPriority(data);
  }, [data]);

  const updatePriorities = (rows: AnalysisPriority[]) => {
    const updatedRows = rows.map((item, index) => ({
      ...item,
      priority: index + 1,
    }));
    setData(updatedRows);
  };

  const handleReorder = (newRows: AnalysisPriority[]) => {
    updatePriorities(newRows);
  };

  const handleMoveUp = (index: number) => {
    if (index === 0) return;
    const newRows = [...data];
    [newRows[index - 1], newRows[index]] = [newRows[index], newRows[index - 1]];
    updatePriorities(newRows);
  };

  const handleMoveDown = (index: number) => {
    if (index === data.length - 1) return;
    const newRows = [...data];
    [newRows[index], newRows[index + 1]] = [newRows[index + 1], newRows[index]];
    updatePriorities(newRows);
  };

  const handleIconBomEmpty = (hasEmpty: boolean) => {
    return hasEmpty && <WarningTooltip messageKey={"bom_not_imported"} />;
  };

  const renderCellHandler = (column: string, index: number, row: any) => {
    if (column === "bom_number") {
      return (
        <TableCell key={index}>
          <Box display="flex" alignItems="center">
            <Typography variant="body1">{row.bom_number}</Typography>
            {handleIconBomEmpty(row.is_empty)}
          </Box>
        </TableCell>
      );
    }
    if (column === "priority") {
      return <TableCell key={index}>{row.priority}</TableCell>;
    }
    if (column === "final_product_description") {
      return <TableCell key={index}>{row.final_product_description}</TableCell>;
    }
    if (column === "modified_at") {
      return <TableCell key={index}>{row.modified_at}</TableCell>;
    }
    return null;
  };

  const renderHeaderCellHandler = (column: string) => {
    return translate.t(column);
  };

  const columns = [
    { field: "priority", headerName: "order", width: 100, minWidth: 100 },
    { field: "part_number", headerName: "model", width: 100, minWidth: 100 },
    { field: "description", headerName: "description", width: 200, minWidth: 200 },
    { field: "import_date", headerName: "imported_at", width: 200, minWidth: 200 },
  ];

  const isRowEmpty = (row: any) => {
    return row.is_empty;
  };

  const headerCellCustomStyleHandler = () => {
    return {
      backgroundColor: "#FFFF !important",
      color: "var(--primary-main) !important",
      borderBottom: "1px solid var(--primary-main)",
      borderTop: "1px solid var(--primary-main)",
      padding: "20px",
    };
  };

  return (
    <section>
      <Paper variant="outlined">
        <Box sx={{ borderBottom: "0px solid #4D14AF" }}>
          <Typography
            sx={{
              color: "#4D14AF",
              fontSize: "16px",
              fontWeight: 530,
              paddingLeft: 1,
              paddingTop: 2,
              paddingBottom: 2,
            }}
          >
            {translate.t("organize_by_priority")}
          </Typography>
        </Box>
        <DraggableTable
          columns={columns}
          headerCellCustomStyle={headerCellCustomStyleHandler}
          rows={dataPriority}
          rowKey="part_number"
          stickyHeader={true}
          onReorder={handleReorder}
          onMoveUp={handleMoveUp}
          onMoveDown={handleMoveDown}
          height={650}
          dateColumns={["import_date"]}
          renderCellHandler={renderCellHandler}
          renderHeaderCellHandler={renderHeaderCellHandler}
          isRowDraggable={isRowEmpty}
          isArrowsDisabled={isRowEmpty}
        />
        {data.length ? (
          <Box sx={{ display: "flex", alignItems: "center", marginTop: 2 }}>
            <Info />
            <Typography sx={{ marginLeft: 1, fontSize: 12, color: "var(--default-color)", fontWeight: 500 }}>
              {translate.t("change_priority")}
            </Typography>
          </Box>
        ) : null}
      </Paper>
    </section>
  );
};

export default SimulationAnalysisPriorityPageComponent;
